/* globals _ */

import api from './api';

const { noop } = _;

export default function( sessionId, callback ) {
	callback = callback || noop;

	api( 'innoway/v2/get_location', { sessionId }, response => {
		callback( response, response.status );
	}, 'POST' );
}
